import HomeworkItem from './HomeworkItem';

export default HomeworkItem;
